import React from 'react';
import styled from 'styled-components';

import { Section, SectionHeader, SectionTitle } from '../styles/Variables';

const SectionBody = styled.div`
	justify-content: space-around;
	flex-direction: row;
	font-family: 'Open Sans', sans serif;
	display: flex;
	width: 100%;

	@media screen and (max-width: 1020px) {
		flex-direction: column;

		ul {
			padding: 0 1rem;
			margin: 1rem auto;
		}
	}
`;

const Column = styled.div`
	justify-content: center;
	flex-direction: column;
	display: flex;
`;

const ColumnHeader = styled.div`
	font-weight: 700;
	text-align: center;
	font-size: 30px;
	color: #8000ff;
`;

const ColumnBody = styled.ul`
	list-style: none;
	padding: 0;
`;

const ColumnBodyItem = styled.li`
	font-weight: 400;
	font-size: 18px;
	margin: 0.5rem 0;
	color: #454545;

	&::before {
		line-height: 0;
		font-weight: bold;
		font-size: 50px;
		content: ". ";
		color: #8000ff;
	}
`;

export const Formation = () => {
	return (
		<Section>
			<SectionHeader align="right" id="formation">
				<SectionTitle color="#8000ff">Minha formação</SectionTitle>
			</SectionHeader>
			<SectionBody>
				<Column>
					<ColumnHeader>Escolaridade</ColumnHeader>
					<ColumnBody>
						<ColumnBodyItem>Ensino Fundamental - SECAT Centro de Ensino</ColumnBodyItem>
						<ColumnBodyItem>Informática - IFRN, Campi Ceará-Mirim</ColumnBodyItem>
						<ColumnBodyItem>Informática para WEB - UFRN, Campus Natal</ColumnBodyItem>	
						<ColumnBodyItem>Graduação em TI - UFRN, Campus Natal</ColumnBodyItem>
					</ColumnBody>
				</Column>
				<Column>
					<ColumnHeader>Certificações</ColumnHeader>
					<ColumnBody>
						<ColumnBodyItem>Certificado de Participação - PythonBrasil [14]</ColumnBodyItem>
						<ColumnBodyItem>Certificado de Participação - Flisol</ColumnBodyItem>
						<ColumnBodyItem>Monitoria de Eletroeletrônica - IFRN, Campi Ceará-Mirim</ColumnBodyItem>
						<ColumnBodyItem>Certificado de MySQL - Curso em Vídeo</ColumnBodyItem>
						<ColumnBodyItem>Certificado de Python - Curso em Vídeo</ColumnBodyItem>
						<ColumnBodyItem>Mensão Honrosa - OBMEP 2016</ColumnBodyItem>
					</ColumnBody>
				</Column>
			</SectionBody>
		</Section>
	);
}